const projects = [
  {
    id: 1,
    title: "Masterprima Company Profile & Blog",
    description: "Problem: Masterprima lacked an online presence to establish credibility and attract leads. Solution: engineered a company profile site integrated with a full CMS for autonomous content management. Impact: a scalable digital foundation that removed the need for ongoing developer involvement in content updates.",
    tags: ["React", "CMS", "CRUD", "Admin Panel", "Full-Stack"],
    imageUrl: "/assets/masterprima.png",
    livePreviewUrl: "https://blog-masterprima.wuaze.com"
  },
  {
    id: 2,
    title: "Student Permit Application",
    description: "Problem: a boarding school's permit workflow was slow and error-prone due to manual, paper-based processes. Solution: architected a multi-level digital approval system with automated WhatsApp notifications and report generation. Impact: eliminated processing bottlenecks and gave administrators real-time visibility over every request.",
    tags: ["Laravel", "Bootstrap 5", "WhatsApp API", "Workflow Automation"],
    imageUrl: "/assets/petik.png"
  },
  {
    id: 3,
    title: "Institutional Website & CMS for STT Stikma",
    description: "Problem: STT Stikma's website was static and costly to maintain, requiring developer intervention for every update. Solution: built a role-based CMS giving non-technical staff full control over institutional content and user access. Impact: reduced IT overhead and kept the institution's public-facing information accurate and current.",
    tags: ["Laravel", "Bootstrap 5", "CMS", "Role-Based Access"],
    imageUrl: "/assets/stikma.png"
  },
  {
    id: 4,
    title: "KUIBIS App",
    company: "PT. Eternal Jaya Engineering",
    description: "Problem: PT. Eternal Jaya Engineering had no unified system for procurement visibility and supplier management. Solution: delivered an enterprise-grade platform with real-time dashboards, dynamic mapping, and a secure payment gateway. Impact: consolidated disparate data sources into a single operational hub, improving decision-making speed.",
    tags: ["Next.js", "Dynamic Maps", "Payment Gateway", "Data Visualization"],
    imageUrl: "/assets/kuibis.png",
  },
  {
    id: 5,
    title: "CodeLearn - Education Platform",
    description: "Problem: existing coding courses lacked interactivity, structure, and a measurable learning path. Solution: built a full LMS on Laravel 11 featuring a rich content editor, student progress tracking, and an admin analytics dashboard. Impact: a production-ready e-learning platform capable of scaling to thousands of concurrent learners.",
    tags: ["Laravel", "PostgreSQL","LMS", "CKEditor", "Chart.js" ],
    imageUrl: "/assets/codelearn.png",
    githubUrl: "https://github.com/ahmdhzq/code-learn.git",
  },
  {
    id: 6,
    title: "Say Cheeze - Online Photobooth",
    description: "Problem: photobooth experiences were tied to physical hardware, limiting accessibility and reach. Solution: engineered a fully browser-based photobooth using Next.js, HTML5 Canvas, and live webcam API integration with custom frames and sticker overlays. Impact: a zero-infrastructure, publicly deployed product with a frictionless end-to-end user experience.",
    tags: ["Next.js", "Tailwind CSS", "HTML5 Canvas", "Webcam API"],
    imageUrl: "/assets/saycheeze.png",
    livePreviewUrl: "https://saycheeze-photobooth.vercel.app/"
  },
];

export default projects;